<template>
  <iframe v-if="iframeSrc" :src="iframeSrc" />
  <!-- If iframeSrc is null, nothing renders here 
       and the parent will switch viewer -->
</template>

<script>
export default {
  name: 'CustomViewer',
  emits: ['fallback-viewer'],
  props: {
    file: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    iframeSrc () {
      let parsedURL
      let finalURL
      let urlParams = new URLSearchParams(window.location.search)
      const customViewerURL = urlParams.get('customViewerUrl')
      const token = this.file[this.file.type].auth_token

      if (!customViewerURL) {
        this.$emit('fallback-viewer')
        return null
      }

      try {
        parsedURL = new URL(customViewerURL)
      } catch (e) {
        this.$emit('fallback-viewer')
        return null
      }

      if (parsedURL.href.includes("{{JWT}}")) {
        finalURL = parsedURL.href.replace("{{JWT}}", token)
      } else {
        this.$emit('fallback-viewer')
        return null
      }
      return finalURL
    }
  }
}
</script>

<style lang="scss">
  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
</style>